/**
 * Marcador `<imported_field>` (ISS-408 / ISS-564) — presentación en el editor.
 *
 * El wrapper es un contenedor anti prompt-injection que se conserva en el
 * contenido consumido por el LLM (system prompts). En la UI se muestra
 * DESENVUELTO (`unwrapImportedField` delega en `stripImportedField` de
 * `@/lib/utils`) y, al guardar un agente que lo tenía (ISS-564), se vuelve a
 * envolver de forma simétrica (`wrapImportedField`) para preservar el prompt
 * efectivo.
 */

import { stripImportedField } from './utils';

const OPEN = '<imported_field>';
const CLOSE = '</imported_field>';
const ESCAPED_CLOSE = '&lt;/imported_field&gt;';

export function isWrappedImportedField(text: string | null | undefined): boolean {
  if (!text) return false;
  const stripped = text.trim();
  return stripped.startsWith(OPEN) && stripped.endsWith(CLOSE);
}

/** Strip a single outer wrapper (presentation). Unknown text is returned
 *  unchanged — same semantics as the backend/`stripImportedField`. */
export function unwrapImportedField(text: string | null | undefined): string {
  return stripImportedField(text);
}

/** Re-wrap display text (idempotent: an already wrapped value is untouched).
 *  Neutralizes inner closing tags so they cannot break out of the wrapper
 *  (mirror of `sanitize_imported_text` in the backend importers). */
export function wrapImportedField(text: string | null | undefined): string {
  const stripped = (text ?? '').trim();
  if (isWrappedImportedField(stripped)) return text ?? '';
  const inner = stripped.split(CLOSE).join(ESCAPED_CLOSE);
  return `${OPEN}\n${inner}\n${CLOSE}`;
}